export default __webpack_public_path__ + "static/media/fontello.4d7431a5.woff";